// import "./datatable.scss";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import {
//   teacherattendanceColumns,
//   teacherattendanceRows,
//   fetchTeacherattendanceRows,
// } from "../../datatablesource";
// import { Link } from "react-router-dom";
// import { useState, useEffect } from "react";
// import { useSlug } from "../../SlugContext";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Loader from "../loader/Loader";
// const TeacherAttendanceDataTable = () => {
//   const [data, setData] = useState(teacherattendanceRows);
//   const [loading, setLoading] = useState(false);
//   const { slugs } = useSlug();
//   useEffect(() => {
//     const getData = async () => {
//       setLoading(true);
//       const rows = await fetchTeacherattendanceRows();
//       console.log("jawad", rows);
//       setLoading(false);
//       setData(Array.from(rows.data));
//     };
//     getData();
//   }, []);

//   const handleDelete = (id) => {
//     // Make a DELETE request to the Flask API endpoint
//     fetch(`${serverUrl}/del_teacher_attendance/${id}`, {
//       method: "DELETE",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error("Failed to delete teacher attendance");
//         }
//         setData(data.filter((item) => item.id !== id));
//         toast.success("Teacher attendance deleted successfully!");
//       })
//       .catch((error) => {
//         console.error("There was a problem with the fetch operation:", error);
//       });
//   };

//   const viewLinkString = "Teacherattendance-Single";
//   const editLinkString = "Teacherattendance-Edit";
//   const newLinkString = "Teacherattendance-New";

//   const actionColumn = [
//     {
//       field: "action",
//       headerName: "Action",
//       width: 200,
//       renderCell: (params) => {
//         return (
//           <div className="cellAction">
//             {slugs && slugs.includes(viewLinkString) && (
//               <Link
//                 to={`/teacher-attendance/${params.row.id}`}
//                 style={{ textDecoration: "none" }}
//               >
//                 <div className="viewButton">View</div>
//               </Link>
//             )}
//             {slugs && slugs.includes(editLinkString) && (
//               <Link
//                 to={`/teacher-attendance/update-teacher-attendance/${params.row.id}`}
//                 style={{ textDecoration: "none" }}
//               >
//                 <div className="editButton">Edit</div>
//               </Link>
//             )}
//             <div
//               className="deleteButton disabled"
//               onClick={() => handleDelete(params.row.id)}
//             >
//               Delete
//             </div>
//           </div>
//         );
//       },
//     },
//   ];
//   return (
//     <div className="datatable">
//       <div className="datatableTitle">Teacher Attendance</div>
//       {loading ? (
//         // <h1 style={{ textAlign: "student", paddingTop: "20%" }}>loading...</h1>
//         <Loader fullScreen={false} />
//       ) : (
//         <DataGrid
//           className="datagrid"
//           rows={data}
//           columns={teacherattendanceColumns.concat(actionColumn)}
//           pageSize={9}
//           rowsPerPageOptions={[9]}
//           components={{
//             Toolbar: GridToolbar, // Include the GridToolbar in the Toolbar slot
//           }}
//         />
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </div>
//   );
// };

// export default TeacherAttendanceDataTable;

import "./datatable.scss";
import {
  teacherattendanceColumns,
  fetchTeacherattendanceRows,
} from "../../datatablesource";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader/Loader";
import RefreshIcon from "@mui/icons-material/Refresh";

const TeacherAttendanceDataTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { slugs } = useSlug();

  const [rowCount, setRowCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);

  const [filters, setFilters] = useState({
    center_id: localStorage.getItem("center_id") || "1",
    class_id: "",
    teacher_id: "",
    date_from: "",
    date_to: "",
  });

  const [classes, setClasses] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [isClassesLoading, setIsClassesLoading] = useState(false);
  const [isTeachersLoading, setIsTeachersLoading] = useState(false);

  // Fetch Classes Dropdown
  useEffect(() => {
    const fetchClasses = async () => {
      setIsClassesLoading(true);
      try {
        const res = await fetch(
          `${serverUrl}/result_dashboard/class_dropdown?centerId=${filters.center_id}`,
        );
        const data = await res.json();
        if (data.code === "200" || data.code === 200) {
          setClasses(data.data || []);
        } else {
          throw new Error("Failed to fetch classes");
        }
      } catch (error) {
        console.error("Error fetching classes:", error);
        toast.error("Failed to load class options.");
      } finally {
        setIsClassesLoading(false);
      }
    };
    fetchClasses();
  }, [filters.center_id]);

  // Fetch Teachers Dropdown (depends on class_id)
  useEffect(() => {
    const fetchTeachers = async () => {
      if (!filters.class_id) {
        setTeachers([]);
        return;
      }
      setIsTeachersLoading(true);
      try {
        const res = await fetch(
          `${serverUrl}/result_dashboard/teacher_dropdown?centerId=${filters.center_id}&classId=${filters.class_id}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ subjectId: null }), // subject filter if needed
          },
        );
        const data = await res.json();
        if (data.code === "200") {
          setTeachers(data.data || []);
        } else {
          throw new Error("Failed to fetch teachers");
        }
      } catch (error) {
        console.error("Error fetching teachers:", error);
        toast.error("Failed to load teacher options.");
      } finally {
        setIsTeachersLoading(false);
      }
    };
    fetchTeachers();
  }, [filters.center_id, filters.class_id]);

  // Fetch Attendance Data
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const rows = await fetchTeacherattendanceRows({
          ...filters,
          page: page + 1,
          limit: pageSize,
        });
        setData(rows.data || []);
        setRowCount(rows.pagination?.total_records || 0);
      } catch (error) {
        console.error("Error fetching teacher attendance:", error);
        toast.error("Failed to load teacher attendance data.");
      }
      setLoading(false);
    };
    getData();
  }, [page, pageSize, filters]);

  // Delete Attendance
  const handleDelete = (id) => {
    fetch(`${serverUrl}/del_teacher_attendance/${id}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete teacher attendance");
        }
        setData(data.filter((item) => item.attendance_id !== id));
        toast.success("Teacher attendance deleted successfully!");
      })
      .catch((error) => {
        console.error("Delete error:", error);
        toast.error("Failed to delete teacher attendance. Please try again.");
      });
  };

  // Handle filter changes
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
    if (name === "class_id") {
      setFilters((prev) => ({ ...prev, teacher_id: "" }));
    }
    setPage(0);
  };

  const handleDateChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
    setPage(0);
  };

  const handleResetFilters = () => {
    setFilters({
      center_id: localStorage.getItem("center_id") || "1",
      class_id: "",
      teacher_id: "",
      date_from: "",
      date_to: "",
    });
    setPage(0);
  };

  // Slug-based links
  const viewLinkString = "Teacherattendance-Single";
  const editLinkString = "Teacherattendance-Edit";
  const newLinkString = "Teacherattendance-New";

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/teacher-attendance/${params.row.attendance_id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/teacher-attendance/update-teacher-attendance/${params.row.attendance_id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}
            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.attendance_id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="datatable p-4">
      <div className="flex flex-col gap-4 mb-5">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full gap-3">
          <div className="text-gray-700 text-2xl font-semibold">
            Teacher Attendance
          </div>
          <div className="flex gap-3">
            <button
              onClick={handleResetFilters}
              className="commonButton w-full sm:w-auto flex items-center justify-center"
              title="Reset Filters"
            >
              <RefreshIcon /> &nbsp; Reset Filters
            </button>
            {slugs && slugs.includes(newLinkString) && (
              <Link
                to="/teacher-attendance/new"
                className="commonButton w-full sm:w-auto"
              >
                Add New
              </Link>
            )}
          </div>
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-4 flex-wrap !mb-5">
          {/* Class Dropdown */}
          <div className="flex-1 min-w-[150px]">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Class
            </label>
            <select
              name="class_id"
              value={filters.class_id}
              onChange={handleFilterChange}
              disabled={isClassesLoading}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
            >
              <option value="">All Classes</option>
              {isClassesLoading ? (
                <option value="">Loading...</option>
              ) : (
                classes.map((cls) => (
                  <option key={cls.id} value={cls.id}>
                    {cls.name}
                  </option>
                ))
              )}
            </select>
          </div>

          {/* Teacher Dropdown */}
          <div className="flex-1 min-w-[150px]">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Teacher
            </label>
            <select
              name="teacher_id"
              value={filters.teacher_id}
              onChange={handleFilterChange}
              disabled={!filters.class_id || isTeachersLoading}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
            >
              <option value="">
                {!filters.class_id
                  ? "Select Class First"
                  : isTeachersLoading
                    ? "Loading..."
                    : "All Teachers"}
              </option>
              {!isTeachersLoading &&
                teachers.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.teacher_name}
                  </option>
                ))}
            </select>
          </div>

          {/* Date Filters */}
          <div className="flex-1 min-w-[150px]">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Date From
            </label>
            <input
              type="date"
              name="date_from"
              value={filters.date_from}
              onChange={(e) => handleDateChange("date_from", e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="flex-1 min-w-[150px]">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Date To
            </label>
            <input
              type="date"
              name="date_to"
              value={filters.date_to}
              onChange={(e) => handleDateChange("date_to", e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* Data Grid */}
      {loading ? (
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          getRowId={(row) => row.attendance_id}
          columns={teacherattendanceColumns.concat(actionColumn)}
          page={page}
          pageSize={pageSize}
          onPageChange={(newPage) => setPage(newPage)}
          onPageSizeChange={(newPageSize) => {
            setPageSize(newPageSize);
            setPage(0);
          }}
          pagination
          paginationMode="server"
          rowCount={rowCount}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          components={{
            Toolbar: GridToolbar,
          }}
          sortModel={[
            {
              field: "attendance_id",
              sort: "desc",
            },
          ]}
        />
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default TeacherAttendanceDataTable;
